<template>
  <button class="btn-success btn">
    <slot></slot>
  </button>
</template>

<script>
export default {};
</script>

<style>
/* button {
  cursor: pointer;
} */

.btn {
  display: inline-block;
  font-weight: 400;
  color: var(--greyBtn);
  text-align: center;
  vertical-align: middle;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-color: transparent;
  border: 1px solid transparent;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  border-radius: 0.35rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.btn-success {
  width: fit-content;
  height: 2.8rem;
  background-color: var(--green);
  color: #fff;
  border-radius: 0.25rem;
  display: flex;
  align-items: center;
  gap: .3rem;
}

/* .btn-success:focus {
    color: #fff;
    background-color: #17a673;
    border-color: #169b6b;
    box-shadow: 0 0 0 0.2rem rgb(62 208 156 / 50%);
} */

.btn-success:hover {
  color: #fff;
  background-color: var(--green);
  /* border-color: #04217e; */
  box-shadow: 0 0 0 0.2rem rgba(41, 218, 70, 0.5);
}

@media (max-width: 320px) {
  .btn-success {
    position: relative;
    left: 1rem;
  }
}
</style>
